<div class="d-lg-flex align-items-center bb-light mb-3">
  <h3 class="d-none d-lg-block">Renter Dashboard</h3>
</div>

<app-getting-started-card
  header="Renting on Rubbl is just like shopping on Amazon. Find equipment from local rental shops and contractors, and get your order placed in minutes. Once placed, we handle everything &#8208; transportation, inspections, insurance, service, repair, and maintenance."
  subheader="For detailed information about the rental process, including payment, usage limits, and insurance <a target='_blank' href='https://support.rubbl.com/getting-started-guide-renters'>click here</a>."
  image="https://company.rubbl.com/pubweb/marketplace/images/backgrounds/shannon-get-started.jpg"
  [gettingStartedCards]="gettingStartedCards"
  capability="Renter"
></app-getting-started-card>

<common-activity-cards [activities]="renterActivities"></common-activity-cards>
<div class="bb-light my-4"></div>

<common-activity-cards header="Renter Actions" [showLength]="false" [activities]="renterActions"></common-activity-cards>
<div class="bb-light my-4"></div>

<div class="mb-1 d-flex justify-content-between">
  <div class="section-header">Latest Rentals</div>
  <a [routerLink]="['/renter/rentals']">View all</a>
</div>
<div class="row">
  <div class="col-md-12">
    <common-index-table
      paginationName="rentals"
      indexName="rental-requests"
      [columns]="columns"
      orderBy="createdDateTime desc"
      [inheritedTypeFilter]="tableFilter"
      rowHeight="125"
      [showSearchInput]="false"
      [externalPaging]="false"
      [top]="5"
      noResultsMessage="There are no rentals in progress. <a href='/equipment-rentals'>Start your search</a>"
    >
    </common-index-table>
  </div>
</div>
